export const NORWEGIAN_MOBILE_NUMBER_PATTERN = /^([4,9,6,7](\d{7}|\d{6})|5\d{11})$/
export const SWEDISH_MOBILE_NUMBER_PATTERN = /^(0?7([0-3,6,9])-?(\d{11}|\d{7}))$/
